import React from 'react';
import { subscriptionTiers } from '../services/subscriptionService';
import { useSubscription } from '../context/SubscriptionContext';
import '../styles/SubscriptionPlan.css';

const SubscriptionPlan = ({ tier, isCurrentPlan, onUpgrade }) => {
  const plan = subscriptionTiers[tier];
  const { subscription } = useSubscription();
  
  // Helper function to determine button text based on tier hierarchy
  const getButtonText = (targetTier, currentTier, targetPrice) => {
    if (targetPrice === 0) return 'Downgrade';
    
    // Define tier hierarchy by price
    const tierOrder = { FREE: 0, PREMIUM: 15, PRO: 50 };
    const currentPrice = currentTier ? tierOrder[currentTier] : 0;
    const targetPriceValue = tierOrder[targetTier] || 0;
    
    return targetPriceValue > currentPrice ? 'Upgrade' : 'Downgrade';
  };
  
  return (
    <div className={`subscription-plan ${isCurrentPlan ? 'current-plan' : ''}`}>
      <div className="plan-header">
        <h3 className="plan-name">{plan.name}</h3>
        <div className="plan-price">
          <span className="price">${plan.price}</span>
          <span className="period">/month</span>
        </div>
      </div>
      
      <div className="plan-limits">
        <div className="limit-item">
          <span className="limit-label">Property Analyses:</span>
          <span className="limit-value">
            {plan.propertyAnalyses === -1 ? 'Unlimited' : plan.propertyAnalyses}
          </span>
        </div>
        <div className="limit-item">
          <span className="limit-label">Chat Messages:</span>
          <span className="limit-value">
            {plan.chatMessages === -1 ? 'Unlimited' : plan.chatMessages}
          </span>
        </div>
      </div>
      
      <div className="plan-features">
        <h4>Features:</h4>
        <ul>
          {plan.features.map((feature, index) => (
            <li key={index}>{feature}</li>
          ))}
        </ul>
      </div>
      
      <div className="plan-actions">
        {isCurrentPlan ? (
          <button className="current-plan-button" disabled>
            Current Plan
          </button>
        ) : (
          <button 
            className="upgrade-button"
            onClick={() => onUpgrade(tier)}
          >
            {getButtonText(tier, subscription?.tier, plan.price)}
          </button>
        )}
      </div>
    </div>
  );
};

export default SubscriptionPlan;